var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28.38 31.62",
    enableBackground: "new 0 0 28.38 31.62",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00386C",
    d: "M24.81,31.62H4.11c-0.34,0-0.61-0.27-0.61-0.61s0.27-0.61,0.61-0.61h20.69c1.3,0,2.35-1.06,2.35-2.35V8.92 c0-0.16-0.06-0.31-0.18-0.43L19.76,1.4c-0.11-0.11-0.26-0.17-0.42-0.17H7.08c-1.3,0-2.35,1.06-2.35,2.35v6.61 c0,0.34-0.27,0.61-0.61,0.61S3.5,10.53,3.5,10.19V3.58C3.5,1.61,5.1,0,7.08,0h12.27c0.48,0,0.94,0.19,1.28,0.52l7.22,7.09 c0.35,0.34,0.55,0.81,0.55,1.3v19.12C28.38,30.01,26.78,31.62,24.81,31.62z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00386C",
    d: "M27.77,10.76h-8.21c-0.71,0-1.29-0.58-1.29-1.29V0.61c0-0.34,0.27-0.61,0.61-0.61s0.61,0.27,0.61,0.61 v8.86l8.27,0.06c0.34,0,0.61,0.27,0.61,0.61S28.11,10.76,27.77,10.76z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00386C",
    d: "M16.29,21.21H0.61C0.27,21.21,0,20.94,0,20.6s0.27-0.61,0.61-0.61h15.68c0.34,0,0.61,0.27,0.61,0.61 S16.63,21.21,16.29,21.21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00386C",
    d: "M11.49,25.97c-0.17,0-0.33-0.07-0.45-0.2c-0.23-0.25-0.21-0.64,0.04-0.87l4.75-4.3l-4.75-4.3 c-0.25-0.23-0.27-0.61-0.04-0.87c0.23-0.25,0.61-0.27,0.87-0.04l5.25,4.76c0.13,0.12,0.2,0.28,0.2,0.45s-0.07,0.34-0.2,0.45 l-5.25,4.76C11.78,25.92,11.63,25.97,11.49,25.97z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportColor);
export default __webpack_public_path__ + "static/media/Export-color.7e2a3748a09ab48abb6f3e29383b3e56.svg";
export { ForwardRef as ReactComponent };